export interface UpdateDefaultParameterOrderDefaultValueRequest {
  id: string
  revision: number
}

export function UpdateDefaultParameterOrderDefaultValueRequestToJSON(
  value: UpdateDefaultParameterOrderDefaultValueRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
